import { bubble as Menu } from 'react-burger-menu';

const Sidebar = (props) => {
  return (
    // Pass on our props
    <Menu {...props}>
      <a className='menu-item' href='#Home'>
        Home
      </a>
      <a className='menu-item' href='#iCancha'>
        iCancha
      </a>
      <a className='menu-item' href='#Centro-Deportivo'>
        Soy un Centro Deportivo
      </a>
      <a className='menu-item' href={process.env.REACT_APP_REDIRECT_SARI} target='_blank' rel='noreferrer'>
        Ingresa a SARi
      </a>
    </Menu>
  );
};

export default Sidebar;